module.exports = Em.Object.extend [
  Em.PromiseProxyMixin,
  Em.Evented
]..., {}